// extracted by mini-css-extract-plugin
module.exports = {"container":"Audio_container__2kLQY","mounted":"Audio_mounted__3jAMe","compact":"Audio_compact__2e7Pn","background":"Audio_background__2ZvQd"};